import { Spinner } from "@blueprintjs/core"
import styled from "styled-components"

export const StyledSpinner = styled(Spinner)<{ color: string }>`
  .bp5-spinner-head {
    stroke: ${({ color }) => color};
  }
`
